const stepData = [
    {
        num: 1,
        step: "STEP 1",
        title: "YOUR INFO"
    },
    {
        num: 2,
        step: "STEP 2",
        title: "SELECT PLAN"
    },
    {
        num: 3,
        step: "STEP 3",
        title: "ADD-ONS"
    },
    {
        num: 4,
        step: "STEP 4",
        title: "SUMMARY"
    },
]

export default stepData